import { render, staticRenderFns } from "./Farmer.vue?vue&type=template&id=1d5bf9fa&lang=html&"
import script from "./Farmer.vue?vue&type=script&lang=js&"
export * from "./Farmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Farmer.vue"
export default component.exports